import type { FlagDictionary } from '@cellula/react';

export type AvailableVisibaLocales =
	| 'sv' // Swedish
	| 'en-gb' // English (United Kingdom)
	| 'da' // Danish
	| 'de' // German
	| 'nb' // Norwegian Bokmål
	| 'fi' // Finnish
	| 'ar' // Arabic
	| 'fa' // Persian
	| 'hr' // Croatian
	| 'nl' // Dutch
	| 'pt-br'; // Portuguese (Brazil)

export function localeToCountry(locale: AvailableVisibaLocales | string): keyof FlagDictionary {
	switch (locale) {
		case 'sv':
			return 'se';
		case 'en-gb':
		case 'en':
			return 'gb';
		case 'da':
			return 'dk';
		case 'de':
			return 'de';
		case 'nb':
		case 'no':
			return 'no';
		case 'fi':
			return 'fi';
		case 'ar':
			return 'sa';
		case 'fa':
			return 'ir';
		case 'nl':
			return 'nl';
		case 'pt-br':
			return 'br';
		default:
			// So it doesn't return undefined or wrong flag.
			return 'N/A' as keyof FlagDictionary;
	}
}
